import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { useLang } from "@/lib/siteI18n";
import { LangSwitcher } from "@/components/LangSwitcher";

export const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="site-footer" className="relative z-10 border-t border-white/10 bg-brand-ink">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-12">
      <div className="md:col-span-2">
        <div className="font-serif text-3xl text-white mb-4">
          AETHERIS <span className="text-gold text-lg align-middle">Académie</span>
        </div>
        <p className="text-white/50 max-w-md leading-relaxed font-light">
          {t.footer.tagline}
        </p>
        <div className="mt-6"><LangSwitcher id="footer-lang" /></div>
        <div className="mt-6 space-y-2 text-sm text-white/50">
          <div className="flex items-center gap-3">
            <Mail size={16} strokeWidth={1.5} className="text-gold" />
            <a href="mailto:gestion.svh@serenite-essence.fr" className="hover:text-white">
              gestion.svh@serenite-essence.fr
            </a>
          </div>
          <div className="flex items-start gap-3">
            <MapPin size={16} strokeWidth={1.5} className="text-gold mt-0.5" />
            <span>55 route de la Démarche, 97233 Schœlcher, Martinique</span>
          </div>
        </div>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-luxe text-gold mb-5">{t.footer.navigation}</h4>
        <ul className="space-y-3 text-sm text-white/60">
          <li><Link to="/services" className="hover:text-white">{t.nav.services}</Link></li>
          <li><Link to="/analyse-de-precision" className="hover:text-white" data-testid="footer-analyse">{t.footer.analyse}</Link></li>
          <li><Link to="/journal" className="hover:text-white">{t.nav.journal}</Link></li>
          <li><Link to="/a-propos" className="hover:text-white">{t.nav.about}</Link></li>
          <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">{t.nav.contact}</Link></li>
          <li><Link to="/portal-access" className="hover:text-white">{t.nav.portal}</Link></li>
          <li><Link to="/diagnostic-inaugural" className="hover:text-white">{t.nav.cta}</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-xs uppercase tracking-luxe text-gold mb-5">{t.footer.legal}</h4>
        <ul className="space-y-3 text-sm text-white/60">
          <li><Link to="/mentions-legales" className="hover:text-white" data-testid="footer-mentions">{t.footer.mentions}</Link></li>
          <li><Link to="/cgv" className="hover:text-white" data-testid="footer-cgv">{t.footer.cgv}</Link></li>
          <li><Link to="/confidentialite" className="hover:text-white" data-testid="footer-confidentialite">{t.footer.privacy}</Link></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-[#C9A84C]/30">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 text-center">
        <p
          data-testid="footer-svh-mention"
          className="text-xs italic"
          style={{ color: "#C9A84C", opacity: 0.7 }}
        >
          {t.footer.brand}
        </p>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <p data-testid="footer-legal-entity">
          © {new Date().getFullYear()} {t.footer.entity}
        </p>
        <p>55 route de la Démarche, 97233 SCHOELCHER — Martinique</p>
      </div>
    </div>
  </footer>
);
};
